import { render, staticRenderFns } from "./EmployeeList.vue?vue&type=template&id=ed263204&scoped=true&"
import script from "./EmployeeList.vue?vue&type=script&lang=ts&"
export * from "./EmployeeList.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeList.vue?vue&type=style&index=0&id=ed263204&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed263204",
  null
  
)

export default component.exports